import { ID, TaskActionType, TimeslotTaskLink } from '@griply/types';

export type TimeslotLinkEntity = {
  id: ID;
  name: string;
};

export const resolveTimeslotLink = (
  entities: TimeslotLinkEntity[],
  id: ID | undefined,
  actionType: TaskActionType,
): TimeslotTaskLink | null => {
  if (!id) {
    return null;
  }
  const entity = entities.find((candidate) => candidate.id === id);
  return entity ? { id: entity.id, name: entity.name, actionType } : null;
};
